import React, { FC } from 'react';
import config from 'app/core/config';
import { Icon, IconName } from '@grafana/ui';

export interface FooterLink {
  text: string;
  icon?: string;
  url?: string;
  target?: string;
}

export let getFooterLinks = (): FooterLink[] => {
  return [
    {
      text: 'Asystom User Guide',
      icon: 'document-info',
      url: 'public/asystom/asystom-userGuide/asystom-user-guides.html',
      target: '_blank',
    },
    {
      text: 'Asystom Website',
      icon: 'external-link-alt',
      url: 'https://www.asystom.com/',
      target: '_blank',
    },
    {
      text: 'Asystom Contact',
      icon: 'comments-alt',
      url: 'https://www.asystom.com/contact-en/',
      target: '_blank',
    },
  ];
};

export let getVersionLinks = (): FooterLink[] => {
  const { buildInfo } = config;
  const links: FooterLink[] = [];

  links.push({ text: `AsystomView 2.0.1`, url: '' });

  if (buildInfo.hideVersion) {
    return links;
  }

  // links.push({ text: `v${buildInfo.version} (${buildInfo.commit})` });

  // if (buildInfo.hasUpdate) {
  //   links.push({
  //     text: `New version available!`,
  //     icon: 'download-alt',
  //     url: 'https://grafana.com/grafana/download?utm_source=grafana_footer',
  //     target: '_blank',
  //   });
  // }

  return links;
};

export function setFooterLinksFn(fn: typeof getFooterLinks) {
  getFooterLinks = fn;
}

export function setVersionLinkFn(fn: typeof getFooterLinks) {
  getVersionLinks = fn;
}

export const Footer: FC = React.memo(() => {
  const links = getFooterLinks().concat(getVersionLinks());

  return (
    <footer className="footer">
      <div className="text-center">
        <ul>
          {links.map(link => (
            <li key={link.text}>
              <a href={link.url} target={link.target} rel="noopener">
                <Icon name={link.icon as IconName} /> {link.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
});
